import { fetchDataForItemPage } from '@/redux/modules/itemPage/itemPage.actions';
import { DataLoaderParams } from '@/types/DataLoaderParams';
import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { UNIFIED_CLIP_VECTOR_VERSION } from '@/utils/amplitude/experiments/hooks/useSimilarLotsUnifiedClip.experiment';
import { getIdFromPath, getNotFoundUrl } from '@/utils/urls';

export const itemPageData = async ({
    amplitudeExperimentFlags,
    location,
    match: { params },
    redirect,
    referrer,
    store: { dispatch },
}: DataLoaderParams) => {
    const itemId = getIdFromPath(params.itemId);

    if (!itemId) {
        return redirect(getNotFoundUrl());
    }

    // Always use new similar items for bots
    const useNewSimilarItems = true;
    // Scout categories should always be true for SSR
    const useScoutCategories = true;

    // Experiment: SEAR-1100 Similar Lots Seller Diversity Capping
    const similarLotsSellerDiversityVariant =
        amplitudeExperimentFlags[AmplitudeExperiments.SimilarLotsSellerDiversity]?.value;
    const hasStrictCapNoBackfill =
        similarLotsSellerDiversityVariant === AmplitudeVariants.SimilarLotsSellerDiversity.StrictCapNoBackfill;
    const hasSoftCapWithBackfill =
        similarLotsSellerDiversityVariant === AmplitudeVariants.SimilarLotsSellerDiversity.SoftCapWithBackfill;

    const hasUnifiedClipTreatment =
        amplitudeExperimentFlags[AmplitudeExperiments.SimilarLotsUnifiedClip]?.value ===
        AmplitudeVariants.SimilarLotsUnifiedClip.Treatment;
    const vectorVersion = hasUnifiedClipTreatment ? UNIFIED_CLIP_VECTOR_VERSION : undefined;

    return dispatch(
        fetchDataForItemPage({
            itemId,
            location,
            redirect,
            referrer,
            shouldUseBackfillAuctioneerLots: hasSoftCapWithBackfill,
            shouldUseMaximumLotsPerAuctioneer: hasSoftCapWithBackfill || hasStrictCapNoBackfill,
            shouldUseSignalsBoost: true,
            useNewSimilarItems,
            useScoutCategories,
            vectorVersion,
        })
    );
};
